/**
 * component/recruit/jobs
 */

import React from 'react';
import { NavLink } from 'react-router-dom';
import Button from 'material-ui/Button';

const initState = [];

const Jobs = ({ item = initState , item_name }) => {
  if(item.length > 0){
    return (
      <div>
        {item.map((key) => {
          return (
            <div className="box-section box-shadow" key={key.name}>
              <h2 className="center-title">{key.name}</h2>
              <table className="border-table full-width">
                <tbody>
                  <Items val={key.item} item_name={item_name} />
                </tbody>
              </table>
            </div>
          )
        })}
        <div className="center-link-btn">
          <Button component={NavLink} to="/contact/" variant="raised" color="secondary" size="large" style={{textAlign:"center",marginBottom:"45px", marginLeft:"auto", marginRight:"auto"}}>
          お問い合わせ
          </Button>
        </div>
      </div>
    )
    
    
  } else {
    return (
      <div className="box-section box-shadow">
        <h3 className="no-data">現在募集しておりません</h3>
      </div>
      
    )
    
  }
  
}


const Items = ({ val,item_name }) => {
  return(
    Object.keys(val).map((key) => {
      return(
        <tr key={key}>
          <th className="border-th">{item_name[key]}</th>
          <td className="border-td"><div dangerouslySetInnerHTML={{__html:val[key]}} /></td>
        </tr>
      )
    })
    
    
    /*
    Object.keys({no:'aa'}).forEach((index) => {
      return(
        <tr>
          <th className="border-th">業務内容</th>
          <td className="border-td">WEBサイトのデザイン、コンテンツ作成、運営、管理業務。</td>
        </tr>
      )
    })
    */
  )
}

export default Jobs;



// WEBPACK FOOTER //
// ./src/component/recruit/Jobs.js